import styled from "styled-components"

export interface StyledGridProps {
  columns_wide: string
  columns_desktop: string
  columns_tablet: string
  columns_mobile: string
  gutters_wide: string
  gutters_desktop: string
  gutters_tablet: string
  gutters_mobile: string
}
export interface StyledColumnProps {
  width_wide: string
  width_desktop: string
  width_tablet: string
  width_mobile: string
}

export const StyledColumn = styled.div<StyledColumnProps>`
  grid-column: span ${(props) => props.width_wide};
  @media (max-width: ${(props) => props.theme.breakPoints.wide}) {
    grid-column: span ${(props) => props.width_desktop};
  }
  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    grid-column: span ${(props) => props.width_tablet};
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    grid-column: span ${(props) => props.width_mobile};
  }
`

export const StyledGrid = styled.div<StyledGridProps>`
  margin: ${props => props.gutters_wide}px 0 0;
  display: grid;
  grid-column-gap: ${(props) => props.gutters_wide}px;
  grid-row-gap: ${(props) => props.gutters_wide}px;
  grid-template-columns: repeat(${(props) => props.columns_wide}, 1fr);
  @media (max-width: ${(props) => props.theme.breakPoints.wide}) {
    grid-template-columns: repeat(${(props) => props.columns_desktop}, 1fr);
    margin: ${props => props.gutters_desktop}px 0 0;
    grid-column-gap: ${(props) => props.gutters_desktop}px;
    grid-row-gap: ${(props) => props.gutters_desktop}px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin: ${props => props.gutters_tablet}px 0 0;
    grid-template-columns: repeat(${(props) => props.columns_tablet}, 1fr);
    grid-column-gap: ${(props) => props.gutters_tablet}px;
    grid-row-gap: ${(props) => props.gutters_tablet}px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin: ${props => props.gutters_mobile}px 0 0;
    grid-template-columns: repeat(${(props) => props.columns_mobile}, 1fr);
    grid-column-gap: ${(props) => props.gutters_mobile}px;
    grid-row-gap: ${(props) => props.gutters_mobile}px;
  }

  & > div {
    min-width: 0;
  }
  & ${StyledColumn} {
    & > div {
      margin-top: ${(props) => props.gutters_wide}px;
      @media (max-width: ${(props) => props.theme.breakPoints.wide}) {
        margin-top: ${(props) => props.gutters_desktop}px;
      }
      @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
        margin-top: ${(props) => props.gutters_tablet}px;
      }
      @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
        margin-top: ${(props) => props.gutters_mobile}px;
      }
      &:nth-of-type(1){
        margin-top: 0;
      }
    }
}
`